import { render } from "./BlockOutdoor.vue?vue&type=template&id=543b357a&scoped=true"
import script from "./BlockOutdoor.vue?vue&type=script&lang=js"
export * from "./BlockOutdoor.vue?vue&type=script&lang=js"

import "./BlockOutdoor.vue?vue&type=style&index=0&id=543b357a&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543b357a"]])

export default __exports__